angular.module('lead')
    .component('leadShow', {
        bindings: {
            item: '<'
        },
        templateUrl: 'app/lead/show.html',
        controller: function ($scope, $state, $window, LeadService, LeadActivityService, Principal) {
            this.LeadService = LeadService;
            this.LeadActivityService = LeadActivityService;

            this.$onInit = () => {
                this.canReadBusinessThread = Principal.hasAnyAuthority(['ROLE_BUSINESS_THREAD']);
                this.canSendSMS = this.item.smsUnlocked && this.hasPhoneNumber();
            }

            this.hasPhoneNumber = () => ((this.item.client?.contacts || []).some(contact => contact && contact.type === 'PHONE' && contact.value)) || ![null, ''].includes(this.item.sourcePhone);

            this.onLeadsLoaded = page => {
                this.leadsCount = page.fullListSize || 0
            }

            this.close = () => $window.history.back();

            $scope.$on('client.updated', () => $state.reload());
            $scope.$on('lead.updated', () => $state.reload());
            $scope.$on('lead.deleted', () => this.close());
            $scope.$on('lead.activity.updated', () => $state.reload());
            $scope.$on('property-deal.updated', () => $state.reload());
        }
    })
